import React from 'react';

import { PageTopBar } from './components/page-top-bar';
import { ProjectsList } from './components/projects-list';
import * as Styled from './projects-overview.style';

export const ProjectsOverview: React.FC = () => (
  <Styled.Container>
    <Styled.Main>
      <Styled.MainContent>
        <PageTopBar />
        <ProjectsList />
      </Styled.MainContent>
    </Styled.Main>
  </Styled.Container>
);
